import React from 'react';
import { Search, DollarSign, Zap, ArrowRight, Clock } from 'lucide-react';
import { Button } from './ui/button';

const HowItWorks = ({ onCTAClick }) => {
  const steps = [
    {
      number: '1',
      icon: Search,
      title: 'Choose Strategy',
      description: 'Browse our AI-filtered strategies. Compare win rates, returns, and risk levels.',
      time: '5 seconds',
      color: '#00D9FF'
    },
    {
      number: '2',
      icon: DollarSign,
      title: 'Set Budget',
      description: 'Start with as low as $100. Your capital stays in your broker account - full control.',
      time: '10 seconds',
      color: '#C9A04B'
    },
    {
      number: '3',
      icon: Zap,
      title: 'Start Copying',
      description: 'Trades execute automatically. Watch your portfolio grow while you sleep.',
      time: 'Automatic!',
      color: '#4ADE80'
    }
  ];

  return (
    <div className="how-it-works-section">
      <div className="how-header">
        <h2 className="how-title">How It Works</h2>
        <p className="how-subtitle">Get started in less than 1 minute</p>
      </div>

      <div className="steps-container">
        {steps.map((step, index) => {
          const Icon = step.icon;
          return (
            <React.Fragment key={index}>
              <div className="step-card">
                <div className="step-number" style={{ backgroundColor: `${step.color}20`, color: step.color }}>
                  {step.number}
                </div>
                <div className="step-icon-wrapper" style={{ backgroundColor: `${step.color}15` }}>
                  <Icon className="step-icon" style={{ color: step.color }} />
                </div>
                <h3 className="step-title">{step.title}</h3>
                <p className="step-description">{step.description}</p>
                <div className="step-time">
                  <Clock className="time-icon" />
                  <span>{step.time}</span>
                </div>
              </div>
              {index < steps.length - 1 && (
                <div className="step-arrow">
                  <ArrowRight className="arrow-icon" />
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>

      <div className="how-cta">
        <div className="total-time-badge">
          <Clock className="badge-icon" />
          <span>Total Setup Time: <strong>Less than 1 minute!</strong></span>
        </div>
        <Button className="btn-primary-sahara btn-xl" onClick={onCTAClick}>
          Start Copying Now
          <Zap className="btn-icon" />
        </Button>
      </div>
    </div>
  );
};

export default HowItWorks;
